/**
 * AuthX evaluates Monarch with the current page URL. The trending experiment
 * is keyed to the homepage request URL, so authX passes the site root URL to
 * keep bucketing aligned with the homepage surface.
 */
export function getHomepageTrendingMonarchParams(): Record<string, unknown> {
  if (typeof window === "undefined") {
    return {};
  }

  if (!window.location.pathname.includes("/authx")) {
    return {};
  }

  const homepageUrl = `${window.location.origin}/`;

  return {
    cohesionPayload: {
      firstRequestUrl: homepageUrl,
      webContext: {
        page: { url: homepageUrl },
      },
    },
  };
}
